import "./index.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { TooltipProvider } from "./components/ui/tooltip";
import { Toaster } from "./components/ui/toaster";
import { BrowserRouter, Route, Routes } from "react-router";
import Home from "./routes/home";
import useVersion from "./hooks/use-version";
import { AccountKitProviders } from './account-kit/AccountKitProvider'
import { config, queryClient } from './account-kit/config'
import { Header } from "./components/layouts/header";
import { Link } from "react-router";
import { cookieToInitialState } from '@account-kit/core'
import { SVGDefs } from "./components/ui/svg-defs";
import { Footer } from "./components/layouts/footer";
import About from "./routes/about";
import Investors from "./routes/investors";
import Partners from "./routes/partners";
import FAQ from "./routes/faq";
import ScrollToTop from "./components/scroll-to-top";
import Contact from "./routes/contact";
import PrivacyPolicy from "./routes/privacy-policy";
import Terms from "./routes/terms";
import NotFound404 from "./routes/not-found-404";
import { AuthProvider } from "./components/auth/AuthContext";
import Dashboard from "./routes/dashboard/dashboard";
import Token from "./routes/dashboard/token";
import DashboardSettings from "./routes/dashboard/settings";
import Blog from "./routes/blog";
import Post from "./routes/post";
import ToggleLogin from "./routes/toggle-login";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://24dad00aa8c0546220a88268d0373711@o4509233322786816.ingest.us.sentry.io/4509233324163072",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

function App() {
    useVersion();
    const initialState = cookieToInitialState(
        config,
        document.cookie ?? undefined
    );
    console.log('initialState', initialState);
    return (
        <QueryClientProvider client={queryClient}>
            <AccountKitProviders initialState={initialState}>
                <div>
                    <SVGDefs />
                    <BrowserRouter>
                        <ScrollToTop />
                        <AuthProvider>
                            <Header />
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/investors" element={<Investors />} />
                                <Route path="/partners" element={<Partners />} />
                                <Route path="/faq" element={<FAQ />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/blog" element={<Blog />} />
                                <Route path="/blog/:slug" element={<Post />} />
                                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                                <Route path="/terms-and-conditions" element={<Terms />} />
                                <Route path="/dashboard" element={<Dashboard />} />
                                <Route path="/dashboard/token" element={<Token />} />
                                <Route path="/dashboard/settings" element={<DashboardSettings />} />
                                <Route path="/404" element={<NotFound404 />} />

                                <Route path="/toggle-login" element={<ToggleLogin />} />
                                <Route path="*" element={<NotFound404 />} />
                            </Routes>
                            <Toaster />
                            <Footer />
                        </AuthProvider>
                    </BrowserRouter>
                </div>
            </AccountKitProviders>
        </QueryClientProvider>
    );
}

export default App;
